module.exports = __webpack_public_path__ + "static/media/destination-printmedia.cb944503.png";